import {inject, Injectable} from '@angular/core';
import {ActivatedRouteSnapshot, CanActivateFn, Router, RouterStateSnapshot} from '@angular/router';
import {StorageKeysEnum} from "../../lib/storage/storage-keys.enum";
import {AuthService} from "../../lib/services/auth/auth.service";
import {catchError, map, Observable, of} from "rxjs";
import {GeolocationService} from "../../lib/services/geolocation/geolocation.service";
import jwt_decode from "jwt-decode";

@Injectable({
    providedIn: 'root'
})
class AuthGuard {
    constructor(private router: Router,
                private authService: AuthService) {
    }

    canActivate(next: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> {
        if (sessionStorage.getItem(StorageKeysEnum.ACCESS_TOKEN) != null
            && sessionStorage.getItem(StorageKeysEnum.ACCESS_TOKEN_WSO) != null) {
            return this.authService.validateTokenSession().pipe(
                map(response => {
                    const valid = !!(response && response.code === 1);
                    if (!valid) {
                        this.authService.logOut();
                        setTimeout(() => location.reload(), 1000);
                    }
                    return valid;
                }),
                catchError(error => {
                    sessionStorage.clear();
                    setTimeout(() => location.reload(), 1000);
                    return of(false);
                })
            );
        } else {
            this.clearSession();
            return of(false);
        }
    }

    clearSession() {
        this.router.navigate(['/login']).then()
    }
}

export const IsAuthGuard: CanActivateFn = (next: ActivatedRouteSnapshot, state: RouterStateSnapshot) => {
    return inject(AuthGuard).canActivate(next, state)
}

